var template = require('../templates/ChoosePassword.html');
var loader = require('../helpers/loader');

module.exports = Backbone.View.extend({

    events: {
        'submit .js-form': 'submit'
    },

    el: '.content',

    initialize: function(options) {
        var self = this;
        self.query = self.parseQuery(options.query);
        this.render();
    },

    render: function() {
        var self = this;
        var base = 'https://www.parse.com/apps/';
        self.$el.html(template({
            action: base + self.query.id + '/request_password_reset',
            username: self.query.username,
            token: self.query.token
        }));
        $('body').addClass('gray-bg');
        self.$('.js-password').strength();
    },

    parseQuery: function(query) {
        // Taken from original reset password template
        var urlParams = {};
        var pair;
        var tokenize = /([^&=]+)=?([^&]*)/g;
        var reSpace = function(s) { return decodeURIComponent(s.replace(/\+/g, ' ')); };
        while ((pair = tokenize.exec(query))) {
            urlParams[reSpace(pair[1])] = reSpace(pair[2]);
        }
        return urlParams;
    },

    submit: function() {
        var self = this;
        var password = self.$('.js-password').val();

        if (password.length < 8) {
            self.$('.js-error')
                .html('The password must be at least 8 characters.')
                .show();
            return false;
        }
        loader.startFullScreen('#change-button');
    }
});



// WEBPACK FOOTER //
// ./app/views/ChoosePassword.js